import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { IndicatorGroupState , IndicatorGroup ,UpdateIndicatorGroup } from './indicatorgroupTypes';

export const createIndicatorGroup = createAsyncThunk(
    'performance/createIndicatorGroup',
    async (data: IndicatorGroup, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/indicatorgroup', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create IndicatorGroup');
      }
    }
  );

  export const fetchAllIndicatorGroup = createAsyncThunk(
    'performance/fetchAllIndicatorGroup',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/indicatorgroup');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all IndicatorGroup');
        }
    }
);

export const fetchIndicatorGroupById = createAsyncThunk(
    'performance/fetchIndicatorGroupById',
    async (IndicatorGroupeId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/indicatorgroup/${IndicatorGroupeId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch IndicatorGroup');
        }
    }
);

export const deleteIndicatorGroup = createAsyncThunk(
    'performance/deleteIndicatorGroup',
    async (IndicatorGroupId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/performance/indicatorgroup/${IndicatorGroupId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete IndicatorGroup');
        }
    }
);

export const updateIndicatorGroup = createAsyncThunk<any , {IndicatorGroupId: number; data: any}, { rejectValue: string }>(
    'performance/updateIndicatorGroup',
    async ({IndicatorGroupId , data}: {IndicatorGroupId : Number; data: Partial<UpdateIndicatorGroup>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/indicatorgroup/${IndicatorGroupId}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create IndicatorGroup');
      }
    }
  ); 

